<script>
    import {onMount} from "svelte";
    import {Link, navigate} from "svelte-routing";
    import moment from "moment";
    import TopMenu from "../components/TopMenu.svelte";
    import Footer from "../components/Footer.svelte";
    import {network, store} from "../stores";
    import {loggerUrl} from "../config.js";

    const user = store('credential', 'getAuth');
    let list = [];
    export let vid;

    let currentDate = moment().utc();
    let dataS = currentDate.clone().startOf('month').subtract(1, 'month');
    let dataPo = currentDate.endOf('month');

    let sDate = dataS.format('YYYY-MM-DD');
    let poDate = dataPo.format('YYYY-MM-DD');

    let isLoading = true
    let loadError = ''
    let listRequest = 0

    let settings = {
        vid: vid ? Number(vid) : 16,
        idKontr: $user.tip.toLowerCase().includes('администратор') ? -1 :+$user.idkontr,
        idSklad: +$user.idSklad,
        data1: dataS.format('DD.MM.YYYY'),
        data2: dataPo.add(1, 'days').format('DD.MM.YYYY')
    }

    const updateDate = (date) => {
        return moment.utc(date).format('DD.MM.YYYY')
    }

    const setSettingsAndGet = (params = {data1: sDate, data2: poDate}) => {
        if (params?.data1){
            params.data1 = updateDate(params.data1)
        }
        if (params?.data2){
            params.data2 = updateDate(params.data2)
        }
        settings = {...settings, ...params};
        getList()
    }

    const changeVid = (newVid) => {
        navigate(`/list/${newVid}`, {replace: true})
        setSettingsAndGet({vid: newVid})
    }


    const getList = async () => {
        const requestId = ++listRequest
        isLoading = true
        loadError = ''

        try {
            const orders = await network.getList(settings)
            if (requestId !== listRequest) {
                return
            }
            if (!Array.isArray(orders)) {
                throw new Error('Пустой ответ')
            }
            list = orders
                .filter((item) => {
                    const isZamer = $user.tip.toLowerCase().includes('замер');
                    if (!isZamer) {
                        return true; // показываем всё
                    }
                    // если "замер", то только если водитель или пользователь — это текущий юзер
                    return item.driver === $user.name || item.polzovatel === $user.name;
                })
                .sort((a, b) => moment(b.data).diff(moment(a.data)));
        } catch (error) {
            if (requestId !== listRequest) {
                return
            }
            console.error(error)
            loadError = 'Не удалось загрузить заявки. Проверьте связь и повторите.'
        }

        isLoading = false
    }

    onMount( async ()=>{
        setSettingsAndGet()
    })

    const openJournal = (item) => {
        const idSklad = parseInt(item.idSklad, 10) || parseInt($user.idSklad, 10);
        const nomerStr = item.nomerStr;
        const storage = String($user.dbname || '').toLowerCase();
        const userName = $user.name || '';

        if (!loggerUrl || !idSklad || !nomerStr) {
            return;
        }

        if (!storage || !userName) {
            alert('Не удалось открыть журнал: нет базы или имени пользователя. Перезайдите в калькулятор.');
            return;
        }

        const url = String(loggerUrl).replace(/\/$/, '')
            + '/' + idSklad + '/' + encodeURIComponent(nomerStr)
            + '?storage=' + encodeURIComponent(storage)
            + '&user_name=' + encodeURIComponent(userName);

        window.open(url, 'axis-logger');
    };


</script>
<style>
    .loading-pulse {
        animation: pulse 1.5s infinite ease-in-out;
    }

    @keyframes pulse {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }

    .spinner-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
    }

    .spinner {
        animation: rotate 2s linear infinite;
        width: 50px;
        height: 50px;
    }

    .spinner .path {
        stroke: #007bff; /* СИНИЙ цвет */
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }

    button.order-journal {
        border: 0;
        cursor: pointer;
        vertical-align: middle;
    }

    button.order-journal:active {
        opacity: 0.7;
    }

    .chip .chip-icon :global(.fa-solid) {
        font-size: 12px;
        line-height: 1;
    }

    :global(.superExtraHeader.list-filters) {
        height: 108px;
        padding: 8px 12px 10px;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        gap: 8px;
        box-shadow: 0 1px 0 #ececec;
    }

    :global(#appCapsule.super-extra-header-active) {
        padding-top: 164px;
    }

    .status-pills {
        display: flex;
        gap: 6px;
    }

    .status-pills button {
        flex: 1 1 0;
        min-width: 0;
        height: 32px;
        padding: 0 4px;
        border: 0;
        border-radius: 999px;
        background: #f1f2f4;
        color: #3d3d3d;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
        white-space: nowrap;
    }

    .status-pills button.active {
        background: #1E74FD;
        color: #fff;
    }

    .period {
        display: flex;
        gap: 8px;
    }

    .period label {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
        height: 36px;
        margin: 0;
        padding: 0 10px;
        border: 1px solid #e6e7eb;
        border-radius: 10px;
        background: #f7f8fa;
    }

    .period span {
        color: #8b919a;
        font-size: 13px;
        font-weight: 600;
    }

    .period input {
        border: 0;
        background: transparent;
        width: 100%;
        min-width: 0;
        padding: 0;
        font-size: 13px;
        color: #141515;
    }

    .period input:focus {
        outline: none;
    }
</style>
<TopMenu title="Мои заявки" />
<div class="superExtraHeader list-filters">
    <div class="status-pills" role="tablist">
        <button type="button" class:active={settings.vid === 16} on:click={() => changeVid(16)}>Черновики</button>
        <button type="button" class:active={settings.vid === 19} on:click={() => changeVid(19)}>В работе</button>
        <button type="button" class:active={settings.vid === 12} on:click={() => changeVid(12)}>На складе</button>
        <button type="button" class:active={settings.vid === 21} on:click={() => changeVid(21)}>Отгруженные</button>
    </div>
    <div class="period">
        <label>
            <span>с</span>
            <input type="date" id="sDate" bind:value={sDate} on:change={() => setSettingsAndGet()}>
        </label>
        <label>
            <span>по</span>
            <input type="date" id="poDate" bind:value={poDate} on:change={() => setSettingsAndGet()}>
        </label>
    </div>
</div>
<div id="appCapsule" class="super-extra-header-active">
    {#if isLoading}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title loading-pulse">Загрузка</h5>
                    <p class="card-text loading-pulse">
                        Пожалуйста подождите, мы загружаем список ваших заявок..
                    </p>
                    <div class="spinner-container mt-4">
                        <svg class="spinner" viewBox="0 0 50 50">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    {:else if loadError}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Нет связи</h5>
                    <p class="card-text">{loadError}</p>
                    <button type="button" class="btn btn-primary" on:click={getList}>Повторить</button>
                </div>
            </div>
        </div>
    {:else}
        {#if list.length > 0}
            <div class="section full">
                <div class="bg-white">
                    <ul class="listview link-listview">
                        {#each list as item (item.vid + '-' + item.nomer)}
                            <li>
                                <Link to="/list/{item.vid}/{item.nomer}" class="row py-3">
                                    <div class="col-12">
                                        <div style="right: 0" class="position-absolute text-end top-0">
                                            <span class="text-muted">{moment(item.data).format('DD.MM.YYYY')}</span>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="col-auto"><h4 class="d-inline">#{item.nomerStr} {item.tipIzd}</h4></div>
                                                    </div>
                                                    <div class="col-12">
                                                        <span>{item.name}</span><br>
                                                        <span>{item.nameKontakt}</span><br>
                                                        <span class="text-danger">{item.komment}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <div class="row text-end">
                                                    <div class="col-12">
                                                        {#if loggerUrl}
                                                            <button
                                                                type="button"
                                                                class="chip chip-media order-journal"
                                                                aria-label="Журнал заказа {item.nomerStr}"
                                                                title="Журнал"
                                                                on:click|preventDefault|stopPropagation={() => openJournal(item)}
                                                            >
                                                                <i class="chip-icon bg-dark">
                                                                    <i class="fa-solid fa-comment-dots"></i>
                                                                </i>
                                                                <span class="chip-label"> </span>
                                                            </button>
                                                        {/if}
                                                        {#if +item.summa}
                                                            <div class="chip chip-media">
                                                                <i class="chip-icon bg-primary">
                                                                    <i class="fa-solid fa-ruble-sign"></i>
                                                                </i>
                                                                <span class="chip-label">{Number((+item.summa).toFixed(0)).toLocaleString("ru-RU")} ₽</span>
                                                            </div>
                                                        {/if}
                                                        {#if +item.summaOpl}
                                                            <div class="chip chip-media">
                                                                <i class="chip-icon bg-success">
                                                                    <i class="fa-solid fa-ruble-sign"></i>
                                                                </i>
                                                                <span class="chip-label">{Number((+item.summaOpl).toFixed(0)).toLocaleString("ru-RU")} ₽</span>
                                                            </div>
                                                        {/if}



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        {/each}
                    </ul>
                </div>
            </div>
            {:else}
                <div class="section mt-2">
                    <div class="card text-center">
                        <div class="card-body p-5">
                            <h5 class="card-title">Ничего не найдено</h5>
                            <p class="card-text">
                                Попробуйте изменить дату или категорию.
                            </p>
                        </div>
                    </div>
                </div>
            {/if}
    {/if}
</div>
<Footer />
